import axAPI from "../../../api/axios-instance";

interface AddSlugParams {
  fnlId: string;
  slug: string;
}

export const addSlug = async ({
  fnlId,
  slug,
}: AddSlugParams): Promise<void> => {
  try {
    const response = await axAPI.post("/cms/fnlId/teams/slug", {
      fnlId,
      slug,
    });

    if (response.status === 200) {
      return;
    } else {
      throw new Error(`Unexpected response: ${response.status}`);
    }
  } catch (error: any) {
    if (error.response) {
      if (error.response.status === 409) {
        throw new Error("Слаг занят другой командой");
      }
      throw new Error(
        `Ошибка при сохранении слага: ${error.response.status} - ${error.response.data}`
      );
    }
    throw new Error("Ошибка сети или неизвестная ошибка");
  }
};
